import { render, staticRenderFns } from "./DictSelector.vue?vue&type=template&id=03f2d5c6&"
import script from "./DictSelector.vue?vue&type=script&lang=js&"
export * from "./DictSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports